import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  className = '',
  onClick
}: CTAButtonProps) {
  return <motion.a href="https://mujercashflow.com/cart/46675194085566:1" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`group relative inline-flex items-center justify-center gap-3 bg-accent hover:bg-accent-hover text-white font-bold py-4 px-8 rounded-full shadow-lg transition-colors duration-300 w-full sm:w-auto text-center text-sm sm:text-base overflow-hidden cursor-pointer no-underline ${className}`} data-id="element-29">
      <span className="relative z-10 flex items-center gap-2" data-id="element-30">
        ¡SÍ! QUIERO MI REINICIO HORMONAL — ACCESO INMEDIATO POR $6.39
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-31" />
      </span>
      <div className="absolute inset-0 h-full w-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-32"></div>
    </motion.a>;
}